import { render, staticRenderFns } from "./CouplesPreview.vue?vue&type=template&id=387c43e9&lang=pug&"
import script from "./CouplesPreview.vue?vue&type=script&lang=js&"
export * from "./CouplesPreview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports